import { getLang } from '@dnb/locale';

const ordinalSuffixes: Record<string, Record<string, string>> = {
  'en-GB': {
    one: 'st',
    two: 'nd',
    few: 'rd',
    other: 'th',
  },
  'nb-NO': {
    other: '.',
  },
};

export function getOrdinal(
  numberToFormat: number,
  locale: string = getLang()
): string {
  if (!Object.keys(ordinalSuffixes).includes(locale)) {
    return `${numberToFormat}`;
  }

  const formatter = new Intl.PluralRules(locale, {
    type: 'ordinal',
  });

  const pluralFormat = formatter.select(numberToFormat);

  const suffix = ordinalSuffixes[locale][pluralFormat];

  return `${numberToFormat}${suffix}`;
}
